import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Breadcrumb } from '../../../utils/models/layout.interface';
import navigationData from '../../../utils/constants/layout/navigation.json';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  private breadcrumbSubject = new BehaviorSubject<Breadcrumb[]>([]);
  public breadcrumb$: Observable<Breadcrumb[]> = this.breadcrumbSubject.asObservable();

  constructor() { }

  /**
   * Define o conteúdo do breadcrumb
   * @param breadcrumbs Array de itens do breadcrumb com label e url
   */
  setBreadcrumb(breadcrumbs: Breadcrumb[]): void {
    this.breadcrumbSubject.next(breadcrumbs);
  }

  /**
   * Adiciona um item ao breadcrumb existente
   * @param breadcrumb Item a ser adicionado
   */
  addBreadcrumb(breadcrumb: Breadcrumb): void {
    const currentBreadcrumbs = this.breadcrumbSubject.value;
    this.breadcrumbSubject.next([...currentBreadcrumbs, breadcrumb]);
  }

  /**
   * Remove o último item do breadcrumb
   */
  removeLastBreadcrumb(): void {
    const currentBreadcrumbs = this.breadcrumbSubject.value;
    if (currentBreadcrumbs.length > 0) {
      this.breadcrumbSubject.next(currentBreadcrumbs.slice(0, -1));
    }
  }

  /**
   * Limpa todo o breadcrumb
   */
  clearBreadcrumb(): void {
    this.breadcrumbSubject.next([]);
  }

  /**
   * Obtém o valor atual do breadcrumb
   */
  getCurrentBreadcrumb(): Breadcrumb[] {
    return this.breadcrumbSubject.value;
  }

  /**
   * Atualiza um item específico do breadcrumb por índice
   * @param index Índice do item a ser atualizado
   * @param breadcrumb Novo conteúdo do item
   */
  updateBreadcrumbByIndex(index: number, breadcrumb: Breadcrumb): void {
    const currentBreadcrumbs = this.breadcrumbSubject.getValue();
    if (index >= 0 && index < currentBreadcrumbs.length) {
      const updatedBreadcrumbs = [...currentBreadcrumbs];
      updatedBreadcrumbs[index] = breadcrumb;
      this.breadcrumbSubject.next(updatedBreadcrumbs);
    }
  }

  /**
   * Remove um item específico do breadcrumb por índice
   * @param index Índice do item a ser removido
   */
  removeBreadcrumbByIndex(index: number): void {
    const currentBreadcrumbs = this.breadcrumbSubject.value;
    if (index >= 0 && index < currentBreadcrumbs.length) {
      const updatedBreadcrumbs = currentBreadcrumbs.filter((_, i) => i !== index);
      this.breadcrumbSubject.next(updatedBreadcrumbs);
    }
  }

  /**
   * Adiciona um item customizado ao breadcrumb existente
   * @param breadcrumb Item a ser adicionado
   */
  addCustomBreadcrumb(breadcrumb: Breadcrumb): void {
    const currentBreadcrumbs = this.breadcrumbSubject.value;
    this.breadcrumbSubject.next([...currentBreadcrumbs, breadcrumb]);
  }

  /**
   * Substitui o último item do breadcrumb por um customizado
   * Útil para casos como "Grupo XYZ" onde XYZ é dinâmico
   */
  replaceLastBreadcrumb(breadcrumb: Breadcrumb): void {
    const currentBreadcrumbs = this.breadcrumbSubject.value;
    if (currentBreadcrumbs.length > 0) {
      const updatedBreadcrumbs = [...currentBreadcrumbs];
      updatedBreadcrumbs[updatedBreadcrumbs.length - 1] = breadcrumb;
      this.breadcrumbSubject.next(updatedBreadcrumbs);
    }
  }
}